document.addEventListener("DOMContentLoaded", function () {
  const breakpoint = window.matchMedia( '(min-width:750px)' );
  let IndexgridSlider;
  const breakpointChecker = function() {
    if ( breakpoint.matches === false ) {
    if ( IndexgridSlider !== undefined ) IndexgridSlider.destroy( true, true );
    return;
      } else if ( breakpoint.matches === true ) {
        return enableSwiper();
      }
  };
  const enableSwiper = function() {
    IndexgridSlider = new Swiper(".productGridswiper.home_bestseller", { slidesPerView: 4, spaceBetween: 15, loop: true, navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev', }, breakpoints: { 300: { slidesPerView: 2, spaceBetween: 10 }, 480: { slidesPerView: 2, spaceBetween: 15 }, 768: { slidesPerView: 3, spaceBetween: 15 }, 1024: { slidesPerView: 4, spaceBetween: 15 }, }, });
  };
  breakpoint.addListener(breakpointChecker);
  breakpointChecker();

  if ( document.querySelectorAll('.productGridswiper').length > 0 && !document.querySelector('.productGridswiper').classList.contains('no-swiper') ){
    new Swiper(".productGridswiper", { slidesPerView: 4, spaceBetween: 15, loop: true, navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev', }, breakpoints: { 300: { slidesPerView: 2, spaceBetween: 10 }, 480: { slidesPerView: 2, spaceBetween: 15 }, 768: { slidesPerView: 3, spaceBetween: 15 }, 1024: { slidesPerView: 4, spaceBetween: 15 }, }, });
  }

  class variantSelection extends HTMLElement{
    constructor(){
      super();
      // NEW: read data-hide before anything touches variant data
      this.hiddenList = this.parseHiddenList();
      this.getFinalDefault();
      this.querySelectorAll('select').forEach((select) => {
        select.addEventListener('change', (event) => {
          this.updateRadioOption();
        });
      });
      // NEW: hard block on add to cart for hidden variants
      this.blockHiddenAddToCart();
    }

    /* ---------- NEW: data-hide helpers ---------- */

    normalizeText(str){
      return String(str || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    // data-hide="Chocolate / 1 Box (500 g), Vanilla / 2 Box (1 kg)"  (variant IDs also accepted)
    parseHiddenList(){
      const raw = this.dataset.hide || '';
      return raw.split(',').map((v) => this.normalizeText(v)).filter(Boolean);
    }

    isHiddenVariant(variant){
      if (!variant || !this.hiddenList.length) return false;
      return this.hiddenList.includes(this.normalizeText(variant.title)) ||
             this.hiddenList.includes(String(variant.id));
    }

    isHiddenId(id){
      const variant = this.getVariantData().find((v) => String(v.id) === String(id));
      return !!(variant && variant.hiddenByAttr);
    }

    // Disables hidden combinations in the dropdowns
    disableHiddenOptions(){
      if (!this.hiddenList.length) return;
      const variants = this.getVariantData();
      const selects = Array.from(this.querySelectorAll('select'));
      const current = selects.map((s) => s.value);

      selects.forEach((select, selectIndex) => {
        Array.from(select.options).forEach((option) => {
          let blocked = false;
          if (selectIndex === 0) {
            // First option (e.g. flavour): block only if every variant under it is hidden
            const related = variants.filter((v) => v.options[0] === option.value);
            blocked = related.length > 0 && related.every((v) => v.hiddenByAttr);
          } else {
            const test = [...current];
            test[selectIndex] = option.value;
            const match = variants.find((v) => v.options.every((o, i) => o === test[i]));
            blocked = !!(match && match.hiddenByAttr);
          }
          if (blocked) option.disabled = true;
        });
      });
    }

    getSubmitButton(){
      return this.closest('.Main__productLayouCg')?.querySelector('[type="submit"]') || null;
    }

    enforceHiddenState(){
      if (!this.isHiddenVariant(this.currentVariant)) return;
      const button = this.getSubmitButton();
      if (!button) return;
      const span = button.querySelector('span');
      if (span) span.innerHTML = `SOLD OUT`;
      button.disabled = true;
    }

    blockHiddenAddToCart(){
      if (!this.hiddenList.length) return;
      const idInput = () => this.querySelector('[name="id"]');
      const form = idInput()?.form || this.closest('form');
      const button = this.getSubmitButton();

      const guard = (event) => {
        const input = idInput();
        if (input && this.isHiddenId(input.value)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.enforceHiddenState();
        }
      };

      // Capture phase on document so it runs before theme / AJAX cart handlers
      if (form) {
        document.addEventListener('submit', (event) => {
          if (event.target === form) guard(event);
        }, true);
      }
      if (button) {
        document.addEventListener('click', (event) => {
          if (button.contains(event.target)) guard(event);
        }, true);
      }
    }

    /* ---------- existing logic (with small changes marked) ---------- */

    getFinalDefault(){
      this.selectedValue();
      this.selectMasterIdDP();
      // NEW: on load, disable hidden combos and move away from a hidden default
      if (this.hiddenList.length) {
        this.disableHiddenOptions();
        if (this.isHiddenVariant(this.currentVariant)) {
          this.autoSelectAvailableOptions();
          this.disableHiddenOptions();
        }
      }
      // this.autoSelectAvailableOptions();
      // this.disableUnavailableOptions();
    }
    updateRadioOption() {
      this.selectedValue();
      this.selectMasterId();
      this.autoSelectAvailableOptions();
      this.triggerProductVariant(false);
      this.disableUnavailableOptions();
      this.disableHiddenOptions(); // NEW
      this.customVariantButtonControl();
    }
    getVariantData(){
      if (!this.variantData) {
        this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        // NEW: hidden variants are treated as unavailable everywhere
        this.variantData.forEach((variant) => {
          if (this.isHiddenVariant(variant)) {
            variant.available = false;
            variant.hiddenByAttr = true;
          }
        });
      }
      return this.variantData;
    }
    selectedValue(select){
      this.choosedOne = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
    selectMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.choosedOne[index] === option;
        }).includes(false);
      });
    }
    selectMasterIdDP() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.choosedOne[index] === option;
        }).includes(false);
      });
      this.customVariantButtonControl();
    }
    disableUnavailableOptions() {
      const variantData = this.getVariantData();
      const selects = this.querySelectorAll('select');
      selects.forEach((select, selectIndex) => {
        if (selectIndex === 0) return;
        const selectedOptions = Array.from(selects).map(sel => sel.value);
        Array.from(select.options).forEach(option => {
          const testOptions = [...selectedOptions];
          testOptions[selectIndex] = option.value;
          const match = variantData.find(variant =>
            variant.options.every((opt, idx) => opt === testOptions[idx])
          );
          option.disabled = match ? !match.available : true;
        });
      });
    }

    autoSelectAvailableOptions() {
      const selects = this.querySelectorAll('select');
      const variantData = this.getVariantData();
      let selected = [];
      selects.forEach((select, index) => {
        selected[index] = select.value;
        const currentSelection = [...selected];
        const validVariant = variantData.find(v =>
          v.options.every((opt, i) => opt === currentSelection[i]) && v.available
        );
        if (!validVariant) {
          let found = false;
          Array.from(select.options).forEach(option => {
            const testSelection = [...selected];
            testSelection[index] = option.value;
            const match = variantData.find(v =>
              v.options.every((opt, i) => opt === testSelection[i]) && v.available
            );
            if (match && !found) {
              select.value = option.value;
              selected[index] = option.value;
              found = true;
            }
          });
        }
      });
      this.selectedValue();
      this.selectMasterId();
      this.triggerProductVariant(false);
    }

    triggerProductVariant(isFallback = false) {
      this.productHandle = this.querySelector('.custom-productElements_variant').dataset.productHandle;
      if (this.currentVariant && this.currentVariant.available) {
       this.querySelector(`[name="id"]`).value = this.currentVariant.id;
         /* Updates product data when variant is changed */
        const variantId = this.currentVariant.id;

        const productLinks = this.closest('[js-product-grid-view]')
          ?.querySelectorAll('a[href*="/products/"]');

        productLinks?.forEach(link => {
          const url = new URL(link.href);
          url.searchParams.set('variant', variantId);
          link.href = url.toString();
        });

       if( this?.querySelectorAll(`#sku-min`).length > 0 ){
        this.querySelector(`#sku-min`).value = this.currentVariant.sku;
       }

       if( this?.querySelectorAll(`#inventory___min`).length > 0 ){
        this.querySelector(`#inventory___min`).value = this.currentVariant.inventory_quantity;
       }

       fetch(`/products/${this.productHandle}?variant=${this.currentVariant.id}`)
        .then( response => { return response.text(); })
        .then( data =>{
          const parser = new DOMParser();
          const ProductHtml = parser.parseFromString(data, 'text/html');
          let primary_image = ProductHtml.querySelector('.grid-hidden-data-layout').dataset.primaryImage;
          let secondary_image = ProductHtml.querySelector('.grid-hidden-data-layout').dataset.secondaryImage;
          let priceGet = ProductHtml.querySelector('.grid-hidden-data-layout').dataset.price;
          let comparePriceGet = ProductHtml.querySelector('.grid-hidden-data-layout').dataset.comparePrice;
          if( secondary_image && this.closest('[js-product-grid-view]').querySelector('[js-product-images-grid]').querySelector('[js-image-secondary]') ){
            this.closest('[js-product-grid-view]').querySelector('[js-product-images-grid]').querySelector('[js-image-secondary]').setAttribute('src',secondary_image);
            this.closest('[js-product-grid-view]').querySelector('[js-product-images-grid]').querySelector('[js-image-secondary]').setAttribute('srcset',secondary_image);
          }
          if(primary_image){
            this.closest('[js-product-grid-view]').querySelector('[js-product-images-grid]').querySelector('[js-image-primary]').setAttribute('src',primary_image);
            this.closest('[js-product-grid-view]').querySelector('[js-product-images-grid]').querySelector('[js-image-primary]').setAttribute('srcset',primary_image);
          }
          this.closest('.Main__productLayouCg').querySelector('.product-price-container').querySelector('.product-price').innerHTML = priceGet;
          if(comparePriceGet){
            this.closest('.Main__productLayouCg').querySelector('.product-price-container').querySelector('.product-compare-price').innerHTML = `<del>${comparePriceGet}</del>`;
          }
          this.closest('.Main__productLayouCg').querySelector('[type="submit"]').querySelector('span').innerHTML = `Add to cart`;
          this.closest('.Main__productLayouCg').querySelector('[type="submit"]').disabled = false;
          this.customVariantButtonControl();
        }).catch( error => { console.log('error', error); })

      // CHANGED: also handles currentVariant being undefined (old code threw an error here)
      }else if (!isFallback) {
        const variants = this.getVariantData();
        const fallbackVariant = variants.find(v => v.available); // hidden variants are already unavailable
        if (fallbackVariant) {
          fallbackVariant.options.forEach((value, index) => {
            const select = this.querySelectorAll('select')[index];
            if (select) {
              select.value = value;
            }
          });
          this.currentVariant = fallbackVariant;
          this.selectedValue();
          this.selectMasterId();
          this.triggerProductVariant(true);
          this.customVariantButtonControl();
        } else {
          const button = this.closest('.Main__productLayouCg').querySelector('[type="submit"]');
          button.querySelector('span').innerHTML = `Sold out`;
          button.disabled = true;
        }
      }
    }

    // CHANGED: wrapper so the hidden check always runs last, after any re-enabling
    customVariantButtonControl() {
      this.legacyButtonControl();
      this.enforceHiddenState();
    }

    // Original customVariantButtonControl, unchanged
    legacyButtonControl() {

       if(this.querySelectorAll('[map-hide-variant="SOLD OUT"]').length > 0){
          const buttonElm = this.closest('.Main__productLayouCg').querySelector('[type="submit"]');
          buttonElm.querySelector('span').innerHTML = `SOLD OUT`;
          buttonElm.disabled = true;
       }

        const hideVariants = this.querySelectorAll('[map-hide-variant]');
        const checkVariants = this.querySelectorAll('[should_be_check]');
        const hideMapFlavours = this.querySelectorAll('[map-hide-flavour-variant]');

       if( checkVariants.length > 0 || hideMapFlavours.length > 0 ){
        const currentTitleEl = this.currentVariant?.title;
        if (!currentTitleEl) return;
        const currentVariantTitle = currentTitleEl;
        const normalizeEl = (str) => str.toLowerCase().replace(/\s+/g, '').replace(/[^a-z0-9]/gi, '');
        const normalizedTitle = normalizeEl(currentVariantTitle);
        let isMatchFound = false;

        for (let el of hideMapFlavours) {
            const variant_new = el.getAttribute('map-hide-flavour-variant');
            const normalizedVariant = normalizeEl(variant_new);
            if (normalizedTitle.indexOf(normalizedVariant) !== -1) {
              isMatchFound = true;
              break;
            }
        }

        if( checkVariants.length > 0 ){
          for (let el of checkVariants) {
              const checkVal = el.getAttribute('should_be_check');
              const normalizedCheck = normalizeEl(checkVal);
              if (normalizedTitle.indexOf(normalizedCheck) !== -1) {
                  isMatchFound = true;
                  break;
              } else{
                for (let el of hideVariants) {
                  const variant = el.getAttribute('map-hide-variant');
                  const normalizedVariant = normalizeEl(variant);
                  const debug_checker = el.getAttribute('check-debug');
                  const debug_checker_normalize = normalizeEl(debug_checker);
                  if( debug_checker.indexOf(checkVal) !== -1 ){
                    break;
                  }else{
                    if ((normalizedTitle.indexOf(normalizedVariant) !== -1) && (document.querySelector(`.variant_select_custom option[map-detect="${variant}"]`).selected == true) ) {
                      isMatchFound = true;
                      break;
                    }
                  }
                }
              }
          }
        }else if( hideVariants.length > 0 ){
          for (let el of hideVariants) {
            const variant = el.getAttribute('map-hide-variant');
            const normalizedVariant = normalizeEl(variant);
            if ((normalizedTitle.indexOf(normalizedVariant) !== -1) && (document.querySelector(`.variant_select_custom option[map-detect="${variant}"]`).selected == true) ) {
              isMatchFound = true;
              break;
            }
          }
        }

        if (isMatchFound) {
          const button = this.closest('.Main__productLayouCg').querySelector('[type="submit"]');
          button.querySelector('span').innerHTML = `SOLD OUT`;
          button.disabled = true;
        } else {
          this.closest('.Main__productLayouCg').querySelector('[type="submit"]').querySelector('span').innerHTML = `Add to cart`;
          this.closest('.Main__productLayouCg').querySelector('[type="submit"]').disabled = false;
        }
      }

      }


  }
  customElements.define('cus-product-variant', variantSelection)
})